import Extend from 'flarum/common/extenders';
import User from 'flarum/common/models/User';
import Impersonate from './models/Impersonate';
export default [new Extend.Store() //
.add('impersonate', Impersonate), new Extend.Model(User) //
.attribute('canFoFImpersonate').attribute('impersonateReasonRequired')];